import React, { Component, useEffect, useRef, useState } from 'react'
import {Route, Switch, withRouter, Redirect} from "react-router-dom"
import { getProduct } from './GetProducts/getProducts';
import AnnouncesBar from './Global_Layouts/AnnouncesBar/AnnouncesBar';
import Footer from './Global_Layouts/Footer/Footer';
import LoaderPage from './Global_Layouts/LoaderPage/LoaderPage';
import Navbar from './Global_Layouts/Navbar/Navbar';
import DefaultPage from './Screens/DefaultPage/DefaultPage';
import Product from './Screens/Product/Product';
import { getUTM } from './Scripts/getUTM';
import { storeData } from './storeData';
import { initializeHIGHLIGHT } from './Scripts/initializeHIGHLIGHT';
import TiktokPixel from 'tiktok-pixel';
import SoldOutProduct from './Screens/SoldOutProduct/SoldOutProduct';
import { preloadImages } from './Helpers/preloadImg';
import { getURLParams } from './Helpers/getURLParams';
import { localstorageCRUD } from './Scripts/localstorageCRUD';
import { setURLParams } from './Helpers/setURLParams';
import CustomToast from './Layouts/CustomToast/CustomToast';
import numeral from 'numeral'
import PurchaseButton from './Global_Layouts/PurchaseButton/PurchaseButton';
import Collection from './Screens/Collection/Collection';
import { getCollectionProducts, getProductsById } from './GetProducts/getCollectionProducts';
import Home from './Screens/Home/Home';
import { deleteURLParams } from './Helpers/deleteURLParams';

let unsubscribeFromProducts = null

class App extends Component {

  state = {
    firstEntry: true,

    quantity: 1,
    first_name: "",
    last_name: "",
    phone_number: "",
    address1: "", // basic info
    address2: "", // extra info
    province: "",
    city: "",
    contact_email: "",
    note: "",

    storeData: storeData(),
    product_data_for_sell: null,
    product_data_for_upsell: null,

    UTM_params: null,

    discount_code: null,
    discount_data: null,

    // STATE FOR CART AND COLLECTIONS
    collection_products:[],
    with_specific_product: getURLParams(["product_id"]).product_id? true : false,
    specific_product_id: getURLParams(["product_id"]).product_id??null,
    loading_collection: false,
    collection_qty: 0,
    selected_collection: [],
    selected_product_from_collection: null,
    cart_items: localstorageCRUD().read("cart_items") || [],
    units: 0,
    free_shipping: true, // change to true after 3 items in cart
    shipping_cost: 0,
    bulk_unit_discount: 20000,
    min_qty_to_get_bulk_discount: 2,
    min_qty_to_get_free_shipping: 0,
    showToast:false,
    message_title: "",
    message_subtitle: "",
    message_description: "",
    message_benefit: "",
    toastTime:600,
    discount_value: 0,
    // STATE FOR CART AND COLLECTIONS

    shipping_type_code: "Normal", // "Rápido con proposito"
  }

  // NEW_FOR_CART
  resetAll = () => {
    this.setState({
    // firstEntry: true,
    quantity: 1,
    first_name: "",
    last_name: "",
    phone_number: "",
    address1: "", // basic info
    address2: "", // extra info
    province: "",
    city: "",
    contact_email: "",
    note: "",
    storeData: storeData(),
    product_data_for_sell: null,
    product_data_for_upsell: null,
    store_with_upsell: false,
    UTM_params: null,
    discount_code: null,
    discount_data: null,
    collection_products:[],
    loading_collection: false,
    collection_qty: 0,
    selected_product_from_collection: null,
    cart_items: localstorageCRUD().read("cart_items") || [],
    units: 0,
    free_shipping: false, // change to true after 3 items in cart
    shipping_cost: 0,
    bulk_unit_discount: 20000,
    min_qty_to_get_bulk_discount: 2,
    min_qty_to_get_free_shipping: 0,
    showToast:false,
    message_title: "",
    message_subtitle: "",
    message_description: "",
    message_benefit: "",
    toastTime:600,
    discount_value: 0
    })
  }

  // NEW_FOR_CART
  setDiscountValue = (discount_value) => {
    this.setState({
      discount_value,
    })
  }

  // NEW_FOR_CART
  componentDidUpdate=(prevProps, prevState)=>{
    const {cart_items, bulk_unit_discount, min_qty_to_get_bulk_discount, min_qty_to_get_free_shipping} = this.state
    let old_units = 0; prevState.cart_items.forEach((item) => {old_units = old_units + item.selectedPackData.quantity}) 
    let new_units = 0; cart_items.forEach((item) => {new_units = new_units + item.selectedPackData.quantity}) 
    if ((prevState.cart_items.length !== cart_items.length) || (old_units !== new_units)) {
      deleteURLParams(["discount_code", "discount_value"])
      this.updateCartData()
    }
  }

  componentDidMount = async () => {
    // NEW_FOR_CART
    this.updateCartData()
    this.props.history.listen((location) => {
      this.setState({firstEntry: false}); // Cambia el estado cuando se navega
    });

    // initializeHIGHLIGHT()
    // const {storeData} = this.state
    // const TT_PIXEL_ID = storeData.tiktok_pixel_id
    // TiktokPixel.init(TT_PIXEL_ID);

    const {storeData} = this.state
    // console.log("storeData from componentDidMount", storeData)
    // const ID_DE_PIXEL_TT = storeData.tiktok_pixel_id?? "CKRFUSJC77U383KU8A6G" // CKRFUSJC77U383KU8A6G used as well in shopify
    const ID_DE_PIXEL_TT = "D2004D3C77U6O99O8IJG" // fashion -> 10X Booster LLC1121 ID: 7303960457017409538

    TiktokPixel.init(ID_DE_PIXEL_TT);

    TiktokPixel.pageView();
    TiktokPixel.track('ViewContent',{
      content_type: 'product',
      content_id: 'ID_del_contenido',
      currency: 'COP',
      value: 139900,
    })

    // const {storeData} = this.state
    const {db} = this.props
    let store_data = storeData
    // let product_id_for_sell = store_data.products[0].product_id_for_sell
    // let store_with_upsell = store_data.products[0].product_with_upsell
    // let product_id_for_upsell = store_data.products[0].product_id_for_upsell

    // let product_data_for_sell = await getProduct(db, product_id_for_sell)
    // preloadImages(product_data_for_sell)
    // let product_data_for_upsell = null;
    // if(store_with_upsell===true){
    //   product_data_for_upsell = await getProduct(db, product_id_for_upsell)
    // }
    // console.log("product_data_for_sell",product_data_for_sell)
    // console.log("product_data_for_upsell",product_data_for_upsell)

    let UTM_params = getUTM()
    // console.log(UTM_params)

    // Remover el loader después de que la app React haya sido montada
    const init_loader = document.querySelector('.init_loader_container');
    if (init_loader) {
      init_loader.remove(); // Eliminamos el loader después de que React carga
    }

    this.setState({
      storeData: store_data,
      // store_with_upsell,
      // product_data_for_sell,
      // product_data_for_upsell,
      UTM_params,
    })

    // this.selectCollection([]) // TODO: X_X GRAN PROBLEMA, CADA ENTRADA A FASHION-COLOMBIA-WEB.APP ESTA CARGANDO TODOS LOS PRODUCTOS DE INSIDE !!!!! x_x
  }

  selectProduct_Data = async (selected_product_data) => {
    const {db} = this.props
    const product_data_for_sell = selected_product_data
    // const store_with_upsell = selected_product_data.product_with_upsell
    // const product_data_for_upsell = selected_product_data.product_id_for_upsell
    const store_product_data = storeData().products.filter((item) => item.product_id_for_sell === product_data_for_sell.id)[0]
    // console.log("store_product_data", store_product_data)
    const store_with_upsell = store_product_data?.product_with_upsell || false
    const product_id_for_upsell = store_product_data?.product_id_for_upsell || null
    const product_data_for_upsell = await getProduct(db, product_id_for_upsell)
    // console.log("product_data_for_upsell", product_data_for_upsell)

    this.setState({
      product_data_for_sell,
      store_with_upsell,
      product_data_for_upsell
    })
  }

  // NEW_FOR_CART
  selectCollection = (selected_collection) => {
    const { db } = this.props;
    // document.querySelector(`.SelectSize`).scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.setState({ loading_collection: true, selected_collection });
    const updateCount = (count) => {
      this.setState({
        collection_qty: count
      })
    };
    const handleFinalProducts = (updatedDoc) => {
      if (!updatedDoc) {
        console.log("Documento no existe o ha sido eliminado");
        return;
      }
      this.setState((prevState) => {
        const products = [...prevState.collection_products];
        // Verifica si este doc ya existe en el array
        const index = products.findIndex((p) => p.id === updatedDoc.id);
        if (index === -1) {
          // Si no existe, lo agregamos
          products.push(updatedDoc);
        } else {
          // Si existe, lo actualizamos
          products[index] = updatedDoc;
        }
        return {
          ...prevState,
          collection_products: products,
          loading_collection: false
        };
      });
      // this.props.history.push('/collection');
    };
    unsubscribeFromProducts = getProductsById(db, this.state.storeData.products, handleFinalProducts);
  }

  componentWillUnmount = () => {
    if (unsubscribeFromProducts) {
      unsubscribeFromProducts()
    }
  }

  // NEW_FOR_CART
  // WORKS GOOD, ADD THE NEW ITEM AT THE END OF THE ARRAY
  // add_to_cart = (item, itemIndex) => {
  //   const { cart_items, units, min_qty_to_get_free_shipping} = this.state;
  //   const new_cart_items = [...cart_items];
  //   if (itemIndex !== undefined && itemIndex >= 0 && itemIndex < cart_items.length) {
  //       new_cart_items[itemIndex] = item;
  //   } else {
  //       new_cart_items.push(item);
  //   }
  //   this.setState({ cart_items: new_cart_items });
  //   if(localstorageCRUD().read("cart_items")){
  //     localstorageCRUD().update("cart_items", new_cart_items)
  //   }else{
  //     localstorageCRUD().create("cart_items", new_cart_items)
  //   }
  //   this.toggleShowToast(true, "¡ AGREGADO !", "third_success")
  // }
  
  // WORKS GOOD FOR ADDING THE NEW ITEM AT THE BEGINNING OF THE ARRAY
  add_to_cart = (item, itemIndex) => {
    window.fbq('track', 'AddToCart');
    TiktokPixel.track('AddToCart', {
      content_type: 'product',
      content_id: 'ID_del_producto',
      currency: 'COP',
      value: 139900,
      content_name: 'Nombre_del_producto',
      quantity: 1,
    });
    const { cart_items } = this.state;
    const new_cart_items = [...cart_items];
    if (
      itemIndex !== undefined && 
      itemIndex >= 0 && 
      itemIndex < cart_items.length
    ) {
      // Si existe un itemIndex válido, reemplazas el ítem en esa posición
      let old_item = new_cart_items[itemIndex]
      let new_item = {...item}
      if (old_item.automatic_added !== true) {
        new_item.automatic_added = false
      }
      new_cart_items[itemIndex] = new_item;
    } else {
      // Si NO hay un itemIndex válido, insertas el nuevo item al inicio
      new_cart_items.unshift(item);
    }
    this.setState({ cart_items: new_cart_items });
    if(localstorageCRUD().read("cart_items")){
      localstorageCRUD().update("cart_items", new_cart_items)
    } else {
      localstorageCRUD().create("cart_items", new_cart_items)
    }
    this.toggleShowToast(true, "¡ AGREGADO !", "third_success");
  }
  

  // NEW_FOR_CART
  updateCartData=()=>{
    const {cart_items, bulk_unit_discount, min_qty_to_get_bulk_discount, min_qty_to_get_free_shipping} = this.state
    let applicable_discount_code = ""
    let units = 0
    cart_items.forEach((item) => {
      units = units + item.selectedPackData.quantity
    })
    if(units===2){
      applicable_discount_code = "BYSIZE_BULK_2"
    } else if (units===3) {
      applicable_discount_code = "BYSIZE_BULK_3"
    } else if (units===4) {
      applicable_discount_code = "BYSIZE_BULK_4"
    } else if (units===5) {
      applicable_discount_code = "BYSIZE_BULK_5"
    } else if (units===6) {
      applicable_discount_code = "BYSIZE_BULK_6"
    } else if (units===7) {
      applicable_discount_code = "BYSIZE_BULK_7"
    } else if (units===8) {
      applicable_discount_code = "BYSIZE_BULK_8"
    } else if (units===9) {
      applicable_discount_code = "BYSIZE_BULK_9"
    } else if (units===10) {
      applicable_discount_code = "BYSIZE_BULK_10"
    } else if (units===11) {
      applicable_discount_code = "BYSIZE_BULK_11"
    } else if (units===12) {
      applicable_discount_code = "BYSIZE_BULK_12"
    }
    this.setState({
      discount_code: applicable_discount_code,
      free_shipping: units >= min_qty_to_get_free_shipping,
      units
    })
    setURLParams("discount_code", applicable_discount_code)
  }

  // NEW_FOR_CART
  remove_from_cart = (item) => {
    const { cart_items, units, min_qty_to_get_free_shipping } = this.state;
    // console.log("cart_items", cart_items)
    // const index = cart_items.findIndex(cartItem => cartItem.ProductData.product_inside_id === item.ProductData.product_inside_id);
    const index = cart_items.findIndex(cartItem => cartItem.ProductData.product_inside_id === item.ProductData.product_inside_id && cartItem.selectedVariants[0].sku === item.selectedVariants[0].sku);
    if (index !== -1) {
      const new_cart_items = [...cart_items.slice(0, index), ...cart_items.slice(index + 1)];
      this.setState({ cart_items: new_cart_items });
      if(localstorageCRUD().read("cart_items")){
        localstorageCRUD().update("cart_items", new_cart_items)
      }else{
        localstorageCRUD().create("cart_items", new_cart_items)
      }
    }
    this.toggleShowToast(true, "¡ REMOVIDO !", "third_success")
  }

  // NEW_FOR_CART
  toggleShowToast = (showToast, message_title, toastType) => {
    this.setState({
      showToast,
      message_title,
      toastType
    })
  }

  // NEW_FOR_CART
  selectProductFromCollection = async (product_data_for_sell) => {
    const product_id = product_data_for_sell.id
    this.setState({product_data_for_sell, specific_product_id: product_id})
    this.props.history.push('/product?product_id='+product_id);
    window.scrollTo(0, 0);
    // window.location.href = '/product?product_id=' + product_id;
  }

  readData = (e) => {
    this.setState({
        [e.target.id]: e.target.value
    })
  }

  // change_product_data_for_sell = (new_product_data_for_sell) => {
  //   this.setState({
  //     product_data_for_sell: new_product_data_for_sell
  //   })
  // }

  render() {
    const { firstEntry, quantity, first_name, last_name, phone_number, address1, address2, province, city, contact_email, note, shipping_type_code } = this.state
    const { product_data_for_sell, store_with_upsell, product_data_for_upsell  } = this.state
    const { storeData, UTM_params, discount_code } = this.state
    const { sizeOnModal, selected_size, collection_products, loading_collection, collection_qty } = this.state
    const { cart_items } = this.state
    const { discount_value, units, free_shipping, shipping_cost, bulk_unit_discount, min_qty_to_get_bulk_discount, min_qty_to_get_free_shipping } = this.state
    // console.log(storeData)

    if(
      (storeData.comodinIdStore === "IwsKN48lzJH1ErgSylA9") ||
      (storeData.comodinIdStore === "9ZJrz2URrntOEyj8RDug") ||
      product_data_for_sell!== null && product_data_for_sell!== undefined && product_data_for_sell!=="" && 
      (store_with_upsell!== true ||
      (product_data_for_upsell!==null && product_data_for_upsell!==undefined && product_data_for_upsell!==""))
    ){
      return (
        <div>
          <AnnouncesBar storeData={storeData}/>
          {/* // NEW_FOR_CART */}
          {/* <div style={{padding:"10px"}}>
            <CustomToast
              message={""}
              message_title={this.state.message_title}
              message_subtitle={this.state.message_subtitle}
              message_description={this.state.message_description}
              message_benefit={this.state.message_benefit}
              type={this.state.toastType}
              duration={this.state.toastTime}
              position="bottom"
              isVisible={this.state.showToast}
              onClose={()=>this.toggleShowToast(false)}
            />
          </div> */}
          <Navbar storeData={storeData}/>
          <div style={{marginTop:"35px", marginBottom:"35px"}}>
            <Switch>
              {/* <Route exact path="/" render={(props)=>(<Product change_product_data_for_sell={this.change_product_data_for_sell} storeData={storeData} {...props} discount_code={discount_code} UTM_params={UTM_params} product_data_for_sell={product_data_for_sell} store_with_upsell={store_with_upsell} product_data_for_upsell={product_data_for_upsell}  readData={this.readData} quantity={ quantity } first_name={ first_name } last_name={ last_name } phone_number={ phone_number } address1={ address1 } address2={ address2 } province={ province } city={ city } contact_email={ contact_email } note={ note }/>)}/> */}
              <Route exact path="/" render={(props)=>(<Home selectProductFromCollection={this.selectProductFromCollection} collection_products={collection_products} product_data_for_sell={product_data_for_sell} cart_items={cart_items} add_to_cart={this.add_to_cart} remove_from_cart={this.remove_from_cart} storeData={storeData} {...props} UTM_params={UTM_params} readData={this.readData} loading_collection={loading_collection} collection_qty={collection_qty}/>)}/>
              <Route exact path="/collection" render={(props)=>(<Collection closeModal={()=>this.setState({visible: false})} resetAll={this.resetAll} discount_value={discount_value} setDiscountValue={this.setDiscountValue} units={units} free_shipping={free_shipping} shipping_cost={shipping_cost} bulk_unit_discount={bulk_unit_discount} min_qty_to_get_bulk_discount={min_qty_to_get_bulk_discount} min_qty_to_get_free_shipping={min_qty_to_get_free_shipping} cart_items={cart_items} add_to_cart={this.add_to_cart} remove_from_cart={this.remove_from_cart} storeData={storeData} {...props} UTM_params={UTM_params} readData={this.readData} selected_size={selected_size} collection_products={collection_products} selectProductFromCollection={this.selectProductFromCollection} discount_code={discount_code} product_data_for_sell={product_data_for_sell} store_with_upsell={store_with_upsell} product_data_for_upsell={product_data_for_upsell} quantity={ quantity } first_name={ first_name } last_name={ last_name } phone_number={ phone_number } address1={ address1 } address2={ address2 } province={ province } city={ city } contact_email={ contact_email } note={ note }/>)}/>
              
              {
                this.state.specific_product_id && (
                  <Route exact path="/product" render={(props)=>(
                    <Product
                      {...props}
                      selectProductFromCollection={this.selectProductFromCollection}
                      collection_products={collection_products}
                      selectProduct_Data={this.selectProduct_Data}
                      specific_product_id={this.state.specific_product_id}
                      db={this.props.db}
                      storeData={storeData} 
                      resetAll={this.resetAll} 
                      discount_value={discount_value} 
                      setDiscountValue={this.setDiscountValue} 
                      setShowToast={(boolean)=>setShowToast(boolean)} 
                      min_qty_to_get_bulk_discount={min_qty_to_get_bulk_discount} 
                      free_shipping={free_shipping} 
                      shipping_cost={shipping_cost} 
                      bulk_unit_discount={bulk_unit_discount} 
                      units={units} 
                      from_cart={true} 
                      cart_items={cart_items} 
                      add_to_cart={this.add_to_cart} 
                      remove_from_cart={this.remove_from_cart}

                      discount_code={discount_code} UTM_params={UTM_params} product_data_for_sell={product_data_for_sell} store_with_upsell={store_with_upsell} product_data_for_upsell={product_data_for_upsell}  readData={this.readData} quantity={ quantity } first_name={ first_name } last_name={ last_name } phone_number={ phone_number } address1={ address1 } address2={ address2 } province={ province } city={ city } contact_email={ contact_email } note={ note } shipping_type_code={shipping_type_code} />)}
                    />
                )
              }
              
              {/* <Route exact path="/collection" render={(props)=>(firstEntry ? <Redirect to="/" /> : <Collection closeModal={()=>this.setState({visible: false})} resetAll={this.resetAll} discount_value={discount_value} setDiscountValue={this.setDiscountValue} units={units} free_shipping={free_shipping} shipping_cost={shipping_cost} bulk_unit_discount={bulk_unit_discount} min_qty_to_get_bulk_discount={min_qty_to_get_bulk_discount} min_qty_to_get_free_shipping={min_qty_to_get_free_shipping} cart_items={cart_items} add_to_cart={this.add_to_cart} remove_from_cart={this.remove_from_cart} storeData={storeData} {...props} UTM_params={UTM_params} readData={this.readData} selected_size={selected_size} collection_products={collection_products} selectProductFromCollection={this.selectProductFromCollection} discount_code={discount_code} product_data_for_sell={product_data_for_sell} store_with_upsell={store_with_upsell} product_data_for_upsell={product_data_for_upsell} quantity={ quantity } first_name={ first_name } last_name={ last_name } phone_number={ phone_number } address1={ address1 } address2={ address2 } province={ province } city={ city } contact_email={ contact_email } note={ note }/>)}/> */}
              <Route exact path="/soldout" render={(props)=>(<SoldOutProduct storeData={storeData} {...props} discount_code={discount_code} UTM_params={UTM_params} product_data_for_sell={product_data_for_sell} store_with_upsell={store_with_upsell} product_data_for_upsell={product_data_for_upsell}  readData={this.readData} quantity={ quantity } first_name={ first_name } last_name={ last_name } phone_number={ phone_number } address1={ address1 } address2={ address2 } province={ province } city={ city } contact_email={ contact_email } note={ note } shipping_type_code={shipping_type_code}/>)}/>
              <Route exact path="/terminos" render={(props)=>(<DefaultPage {...props} page={"terminos"} storeData={storeData}/>)}/>
              <Route exact path="/devoluciones" render={(props)=>(<DefaultPage {...props} page={"devoluciones"} storeData={storeData}/>)}/>
              <Route exact path="/envios" render={(props)=>(<DefaultPage {...props} page={"envios"} storeData={storeData}/>)}/>
              <Route exact path="/privacidad" render={(props)=>(<DefaultPage {...props} page={"privacidad"} storeData={storeData}/>)}/>
              <Route exact path="/nosotros" render={(props)=>(<DefaultPage {...props} page={"nosotros"} storeData={storeData}/>)}/>
              <Route exact path="/contacto" render={(props)=>(<DefaultPage {...props} page={"contacto"} storeData={storeData}/>)}/>
            </Switch>
          </div>
          {/* NEW_FOR_CART */}
          {
            this.props.location.pathname === "/product" && cart_items.length < 1 ? null :
            <div className='sticky-footer'>
              <ShoppingCartWidget
                resetAll={this.resetAll}
                discount_value={discount_value}
                setDiscountValue={this.setDiscountValue}
                cart_items={cart_items}
                add_to_cart={this.add_to_cart}
                remove_from_cart={this.remove_from_cart}
                readData={this.readData}
                quantity={quantity}
                first_name={first_name}
                last_name={last_name}
                phone_number={phone_number}
                address1={address1}
                address2={address2}
                province={province}
                city={city}
                contact_email={contact_email}
                note={note}
                shipping_type_code={shipping_type_code}
                UTM_params={UTM_params}
                discount_code={discount_code}
                product_data_for_sell={product_data_for_sell}
                store_with_upsell={store_with_upsell}
                product_data_for_upsell={product_data_for_upsell}
                units={units}
                free_shipping={free_shipping}
                shipping_cost={shipping_cost}
                bulk_unit_discount={bulk_unit_discount}
                min_qty_to_get_bulk_discount={min_qty_to_get_bulk_discount}
                min_qty_to_get_free_shipping={min_qty_to_get_free_shipping}
              />
            </div>
          }
          <Footer storeData={storeData}/>
        </div>
      )
    } else if (storeData?.products[0]?.is_sold_out) {
      return (
        <div>
          <AnnouncesBar storeData={storeData}/>
          <Navbar storeData={storeData}/>
          <div style={{marginTop:"35px", marginBottom:"35px"}}>
            <Switch>
              <Route exact path="/" render={(props)=>(<LoaderPage {...props} storeData={storeData}/>)}/>
              <Route exact path="/soldout" render={(props)=>(<SoldOutProduct storeData={storeData} {...props} discount_code={discount_code} UTM_params={UTM_params} product_data_for_sell={product_data_for_sell} store_with_upsell={store_with_upsell} product_data_for_upsell={product_data_for_upsell}  readData={this.readData} quantity={ quantity } first_name={ first_name } last_name={ last_name } phone_number={ phone_number } address1={ address1 } address2={ address2 } province={ province } city={ city } contact_email={ contact_email } note={ note } shipping_type_code={shipping_type_code}/>)}/>
              <Route exact path="/terminos" render={(props)=>(<DefaultPage {...props} page={"terminos"} storeData={storeData}/>)}/>
              <Route exact path="/devoluciones" render={(props)=>(<DefaultPage {...props} page={"devoluciones"} storeData={storeData}/>)}/>
              <Route exact path="/envios" render={(props)=>(<DefaultPage {...props} page={"envios"} storeData={storeData}/>)}/>
              <Route exact path="/privacidad" render={(props)=>(<DefaultPage {...props} page={"privacidad"} storeData={storeData}/>)}/>
              <Route exact path="/nosotros" render={(props)=>(<DefaultPage {...props} page={"nosotros"} storeData={storeData}/>)}/>
              <Route exact path="/contacto" render={(props)=>(<DefaultPage {...props} page={"contacto"} storeData={storeData}/>)}/>
            </Switch>
          </div>
          <Footer storeData={storeData}/>
        </div>
      )
    } else {
      return (
        <div>
          <AnnouncesBar storeData={storeData}/>
          <Navbar storeData={storeData}/>
            <LoaderPage storeData={storeData}/>
          <Footer storeData={storeData}/>
        </div>
      )
    }
  }
}


export default withRouter(App);


{/* NEW_FOR_CART */}
export function ShoppingCartWidget({ 
  cart_items, add_to_cart, remove_from_cart,
  readData, quantity, first_name, last_name, phone_number, address1, address2, province, city, contact_email, note, shipping_type_code,
  UTM_params, discount_code, product_data_for_sell, store_with_upsell, product_data_for_upsell,
  from_purchase_form,
  free_shipping, shipping_cost, bulk_unit_discount, min_qty_to_get_bulk_discount, min_qty_to_get_free_shipping,
  units,
  discount_value, setDiscountValue,
  resetAll
}) {
const widgetRef = useRef(null);
const [showToast, setShowToast] = useState(false)
const [toastMsg, setToastMsg] = useState("")
const [message_title, setMessage_title] = useState("")
const [message_subtitle, setMessage_subtitle] = useState("")
const [message_description, setMessage_description] = useState("")
const [message_benefit, setMessage_benefit] = useState("")
const [toastType, setToastType] = useState("")
const [toastTime, setToastTime] = useState(3000)

useEffect(() => {
  const adjustFooterMargin = () => {
    const footer = document.getElementById('Footer');
    if (footer && widgetRef.current) {
      footer.style.marginBottom = `${widgetRef.current.clientHeight}px`;
    }
  };
  adjustFooterMargin();
  window.addEventListener('resize', adjustFooterMargin);
  return () => {
    window.removeEventListener('resize', adjustFooterMargin);
  };
}, []);

useEffect(() => {
  if(units>0 && from_purchase_form!==true){
    if (units < min_qty_to_get_bulk_discount) {
      setMessage_title("📣 OFERTA")
      setMessage_description("POR CADA PAR ADICIONAL")
      setMessage_benefit("GANAS BONO DE "+numeral(bulk_unit_discount).format('$ 0,0'))
      setToastType("first_success")
      setToastTime(4000)
      setTimeout(() => {
        setShowToast(true)
      }, 600);
    } else if (units >= min_qty_to_get_bulk_discount) {
      setMessage_title("📣 SUPER OFERTA")
      setMessage_description("AGREGA 1 PAR MAS PARA")
      setMessage_benefit(`GANAR BONO DE ${numeral((units*bulk_unit_discount)).format('$ 0,0')}`)
      setToastType("second_success")
      setToastTime(4000)
      setTimeout(() => {
        setShowToast(true)
      }, 600);
    }
    
    // else if (units > min_qty_to_get_free_shipping) {
    //   setMessage_title("AGREGADO!")
    //   setMessage_description("")
    //   setMessage_benefit("")
    //   setToastType("third_success")
    //   setToastTime(600)
    //   setShowToast(true)
    // }
  }
}, [units])

let message = {}
let applied_discount = 0

// if (units < min_qty_to_get_bulk_discount) {
  message.regular = "1 MÁS PARA"
  message.bold = "GANAR "+numeral(units*bulk_unit_discount).format('$ 0,0')
// }

// if (units === min_qty_to_get_bulk_discount) {
//   message.regular = "LLEVA 1 MAS Y"
//   message.bold = "GANA ENVIO GRATIS"
//   applied_discount = min_qty_to_get_bulk_discount*bulk_unit_discount
// }

// if (units >= min_qty_to_get_free_shipping) {
//   message.regular = "¡GENIAL! "
//   message.bold = "AHORRO AL MAXIMO"
//   applied_discount = units*bulk_unit_discount + shipping_cost
// }

let subtotal = 0;
let totalDiscount = 0;
cart_items.forEach(item => {
    subtotal += item?.selectedPackData?.comparative_price;
    totalDiscount += item?.selectedPackData?.discount??0;
});

// applied_discount = (units-1)*bulk_unit_discount
const def_units = units === 2? 1 : units;
applied_discount = totalDiscount>0? 0 : ((units>=min_qty_to_get_bulk_discount)? (bulk_unit_discount*(def_units)) : 0);
const def_discount = applied_discount>0? applied_discount : totalDiscount>0? totalDiscount : 0;

let total = (subtotal - totalDiscount);
console.log("total", total)
let total_with_shipping = total
if(free_shipping!==true){
  total_with_shipping = (total + shipping_cost - applied_discount)
} else {
  total_with_shipping = (total - applied_discount)
}

return (
  <div className={cart_items.length>0?from_purchase_form!==true?"ShoppingCartWidget":"ShoppingCartWidgetForm":"ShoppingCartWidget_empty"} ref={widgetRef}>
    {cart_items.length>0?
    <div>
      <div style={{fontWeight:"bold", fontSize:"15px", marginBottom:"10px"}}>Carrito de compra ({units})</div>
      
      <div className='ShoppingCartWidget_upper'>
        <div className={from_purchase_form!==true?'ShoppingCartWidget_upper_items_container':'ShoppingCartWidget_upper_items_container_all'}>
          <div className='ShoppingCartWidget_upper_items_container_upper'>
            {
              cart_items.map(item=>
                item.selectedVariants.map(variant=>
                  <ShoppingCartBox item={item} variant={variant} remove_from_cart={remove_from_cart}/>
                )
              )
            }
          </div>

          {
            from_purchase_form!==true?
            <div className='ShoppingCartWidget_upper_items_container_down'>
              <div className='ShoppingCartWidget_upper_items_container_down_msg'>
                <span className='ShoppingCartWidget_upper_items_container_down_msg_regular'>✨{message.regular}</span>
                <strong className='ShoppingCartWidget_upper_items_container_down_msg_bold'>{message.bold}</strong>
              </div>
              <progress style={{width:`95%`, height:"30px"}} id="file" value={`${Math.min(((units/12)*100),100)}`} max="100"> {`${Math.min(((units/min_qty_to_get_free_shipping)*100),100)}%`} </progress>
            </div>
            :
            null
          }  

        </div>
        {
          from_purchase_form!==true?
          <div className='ShoppingCartWidget_upper_order_price'>
            <ShoppingCartBoxPriceList price={subtotal} label={"SUBTOTAL"} color={"black"} fontWeight={"500"} fontWeightLabel={"200"} simbol={"+"}/>
            <ShoppingCartBoxPriceList price={free_shipping?0:shipping_cost} label={"ENVIO"} color={"black"} fontWeight={"500"} fontWeightLabel={"200"} simbol={"+"}/>
            
            <div className={def_discount>0?`ShoppingCartBoxPriceListDiscount`:""}>
              <ShoppingCartBoxPriceList price={def_discount} label={"DESCUENTO"} color={def_discount>0?"#02c861":"black"} fontWeight={"500"} fontWeightLabel={def_discount>0?"bold":"200"} simbol={"- "}/> 
            </div>

            <div style={{borderTop:"1px solid black", paddingTop:"12px", marginTop:"12px"}} >
              <ShoppingCartBoxPriceList price={total_with_shipping} label={"TOTAL"} color={"black"} fontWeight={"bold"} fontWeightLabel={"normal"} simbol={"="} fontSize={"20px"}/>
            </div>
          </div>
          :
          null
        }
      </div>
      {
        from_purchase_form!==true?
        <div className='sticky-footer'>
          <PurchaseButton animation_disabled={true} resetAll={resetAll} discount_value={discount_value} setDiscountValue={setDiscountValue} setShowToast={(boolean)=>setShowToast(boolean)} min_qty_to_get_bulk_discount={min_qty_to_get_bulk_discount} free_shipping={free_shipping} shipping_cost={shipping_cost} bulk_unit_discount={bulk_unit_discount} units={units} from_cart={true} cart_items={cart_items} add_to_cart={add_to_cart} remove_from_cart={remove_from_cart} discount_code={discount_code} UTM_params={UTM_params} product_data_for_upsell={product_data_for_upsell} selectedVariants={null} getSelectedVariants={null} ProductData={null} getSelectedPackData={null} selectedPackId={null} selectedPackData={null}  readData={readData} quantity={ quantity } first_name={ first_name } last_name={ last_name } phone_number={ phone_number } address1={ address1 } address2={ address2 } province={ province } city={ city } contact_email={ contact_email } note={ note } shipping_type_code={shipping_type_code}/>
        </div>
        :
        null
      }
      {
        from_purchase_form!==true?
        null
        // <CustomToast
        //   message={toastMsg}
        //   message_title={message_title}
        //   message_subtitle={message_subtitle}
        //   message_description={message_description}
        //   message_benefit={message_benefit}
        //   type={toastType}
        //   duration={toastTime}
        //   position="bottom"
        //   isVisible={showToast}
        //   onClose={()=>setShowToast(false)}
        // />
        :
        null
      }
    </div>
    :
    <div>CARRITO DE COMPRA VACIO</div>
    }
  </div>
);
}
{/* NEW_FOR_CART */}
export function ShoppingCartBox({item, variant, remove_from_cart}) {
  let sku_img = item.ProductData.productVariations.find(variation => variation.variation_sku === variant.sku)?.variation_img_src || "";
  let size = item.ProductData.productVariations.find(variation => variation.variation_sku === variant.sku)?.variation_title.split("/")[1] || ""; 
  // Estilo para el fondo del ShoppingCartBox
  const boxStyle = {
    backgroundImage: `url(${sku_img})`, // Usa la imagen obtenida como fondo
    backgroundSize: 'cover',            // Cubre todo el contenedor con la imagen
    backgroundPosition: 'center',       // Centra la imagen en el contenedor
    backgroundRepeat: 'no-repeat',      // Evita que la imagen se repita
  };

  return (
    <div>
      <div className='ShoppingCartBox' style={boxStyle}>
        <div className='ShoppingCartBox_size'>
          {size}
        </div>
        <div onClick={() => remove_from_cart(item)} className='ShoppingCartBox_remove'>
          X
        </div>
        <div className='ShoppingCartBox_price'>
          {numeral(item.selectedPackData.unitary_price).format("$ 0,0")}
        </div>
      </div>
    </div>
  )
}
{/* NEW_FOR_CART */}
function ShoppingCartBoxPriceList({price, label, color, fontWeight, fontWeightLabel, simbol, fontSize}) {
  return (
    <div className='ShoppingCartBoxPriceList' style={{color}}>
      <div className='ShoppingCartBoxPriceList_price' style={{fontWeight, fontSize: fontSize}}>{simbol}{numeral(price).format(`$ 0,0`)}</div>
      <div className='ShoppingCartBoxPriceList_label' style={{fontWeight: fontWeightLabel}}>{label}</div>
    </div>
  )
}
